// src/mcp/schemas.ts
import { z } from "zod";
var ColumnDefSchema = z.object({
  /** Data field key (supports nested paths with dots, e.g., "core.keyword"). */
  key: z.string(),
  /** Column header label. */
  label: z.string(),
  /** Display format. */
  format: z.enum(["text", "number", "badge", "date"]).optional(),
  /** Tailwind alignment class. */
  align: z.enum(["left", "right", "center"]).optional()
});
var FieldDefSchema = z.object({
  /** Data field key (supports nested paths). */
  key: z.string(),
  /** Display label. */
  label: z.string(),
  /** Display format. */
  format: z.enum(["text", "number", "badge", "json", "list"]).optional()
});
var SectionDefSchema = z.object({
  /** Section subtitle. */
  title: z.string(),
  /** Section type. */
  type: z.enum(["table", "kv", "detail"]),
  /** Data path relative to parent dataPath. */
  dataPath: z.string().optional(),
  /** Items path for table sections. */
  itemsPath: z.string().optional(),
  /** Column definitions for table sections. */
  columns: z.array(ColumnDefSchema).optional(),
  /** Field definitions for detail/kv sections. */
  fields: z.array(FieldDefSchema).optional()
});
var WidgetConfigSchema = z.object({
  type: z.enum(["table", "detail", "kv", "json", "multi"]),
  title: z.string(),
  /** Path to extract data from the structured content. */
  dataPath: z.string().optional(),
  /** Path to extract items array for tables. */
  itemsPath: z.string().optional(),
  /** Path to extract pageInfo for tables. */
  pageInfoPath: z.string().optional(),
  /** Column definitions for table type. */
  columns: z.array(ColumnDefSchema).optional(),
  /** Field definitions for detail type. */
  fields: z.array(FieldDefSchema).optional(),
  /** Section definitions for multi type. */
  sections: z.array(SectionDefSchema).optional()
});

// src/mcp/utils.ts
function getByPath(obj, path) {
  if (!obj || typeof obj !== "object") return void 0;
  const parts = path.split(".");
  let current = obj;
  for (const part of parts) {
    if (current == null || typeof current !== "object") return void 0;
    current = current[part];
  }
  return current;
}
function formatValue(value, format) {
  if (value == null) return "-";
  switch (format) {
    case "number":
      return typeof value === "number" ? value.toLocaleString() : String(value);
    case "date":
      return String(value);
    case "json":
      return JSON.stringify(value, null, 2);
    case "list":
      return Array.isArray(value) ? value.join(", ") : String(value);
    default:
      return String(value);
  }
}

export {
  ColumnDefSchema,
  FieldDefSchema,
  SectionDefSchema,
  WidgetConfigSchema,
  getByPath,
  formatValue
};
//# sourceMappingURL=chunk-4LYFAOBR.js.map